(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/self-selected-quote-rank/render"] = factory(require("VueDemi"), require("FEGOWebapi"));
	else
		root["/fego/component/self-selected-quote-rank/render"] = factory(root["VueDemi"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 